import { AxiosService } from './axios.service'

/**
 * Defines the API methods for a credit card
 */
export class CreditCardService {
	static baseURL = 'cliente/cartoes-credito'

	/**
	 * Gets the list of credit cards of the current user
	 * @return {Promise<string[]>} credit card list
	 */
	static getCreditCard() {
		return AxiosService.get(`${this.baseURL}`)
			.then(({ data }) => data)
			.catch([])
	}

	/**
	 * Gets the list of credit cards of the current user from safe box
	 * @return {Promise<string[]>} credit card list
	 */
	static getAllSavedCreditCards() {
		return AxiosService.get(`${this.baseURL}/listar-cofre`)
			.then(({ data }) => data)
			.catch([])
	}

	/**
	 * Set the credit card as inactivated
	 * @return {Promise<Object>} reponse object with the status
	 */
	static inactivateCreditCard(creditCardId) {
		return AxiosService.post(`${this.baseURL}/inativar`, {
			creditCardId: creditCardId,
		})
			.then((data) => data)
			.catch((data) => data)
	}

	/**
	 * Set the credit card as main card
	 * @return {Promise<Object>} reponse object with the status
	 */
	static setCrediCardAsMainCard(creditCardId) {
		return AxiosService.post(`${this.baseURL}/definir-como-principal`, {
			creditCardId: creditCardId,
		})
			.then((data) => data)
			.catch((data) => data)
	}

	/**
	 * Adds a new credit card
	 * @return {Promise<Object>} reponse object with the status
	 */
	static addCard({
		cardPrintedName,
		cardNumber,
		cardMonthValidity,
		cardYearValidity,
		isMainCard,
	}) {
		return AxiosService.post(`${this.baseURL}/adicionar`, {
			name: cardPrintedName,
			number: cardNumber,
			expirationMonth: cardMonthValidity,
			expirationYear: cardYearValidity,
			main: isMainCard,
		})
			.then((data) => data)
			.catch((data) => data)
	}

	/**
	 * Get installmets value to creditcard
	 * @return {Promise<any[]>}
	 */
	static GetInstallmentsOptions(totalValue) {
		const optUrl = `creditcard/buscar-opcoes-parcelamento?totalValue=${totalValue}`
		return AxiosService.getKeepLatest('creditcard-installments', optUrl)
			.then(({ data }) => data)
			.catch(() => [])
	}
}
